import { render, staticRenderFns } from "./stores-manager.vue?vue&type=template&id=385bdcff&lang=pug&"
import script from "./stores-manager.vue?vue&type=script&lang=js&"
export * from "./stores-manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports